import {createSlice} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import type {SliceTooltipTracesInterface} from '@shared/interfaces/trace'
import type {RootState} from '@containers/App/store'

interface SliceTooltipProps {
  open: boolean
  isTooltipHovered: boolean
  xValue: number | Date
  program: string
  traces: SliceTooltipTracesInterface[]
  staticTooltipOpen: boolean
  xPosition: number
  xDomain: [number | Date, number | Date] | null
  cursorPosition: number
  descriptionSignalId: string
  isModelInstanceGraph: boolean
}

const initialState: SliceTooltipProps = {
  open: false,
  isTooltipHovered: false,
  xValue: 0,
  program: '',
  traces: [],
  staticTooltipOpen: false,
  xPosition: 0,
  xDomain: null,
  cursorPosition: 0,
  descriptionSignalId: '',
  isModelInstanceGraph: false,
}

export const sliceTooltip = createSlice({
  name: 'sliceTooltip',
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => ({
      ...state,
      open: action.payload,
    }),
    setStaticTooltipOpen: (state, action: PayloadAction<boolean>) => ({
      ...state,
      staticTooltipOpen: action.payload,
    }),
    setXValue: (state, action: PayloadAction<number | Date>) => ({
      ...state,
      xValue: action.payload,
    }),
    setXPosition: (state, action: PayloadAction<number>) => ({
      ...state,
      xPosition: action.payload,
    }),
    setCursorPosition: (state, action: PayloadAction<number>) => ({
      ...state,
      cursorPosition: action.payload,
    }),
    setGlobalXDomain: (state, action: PayloadAction<[number | Date, number | Date] | null>) => ({
      ...state,
      xDomain: action.payload,
    }),
    setTraces: (state, action: PayloadAction<SliceTooltipTracesInterface[]>) => ({
      ...state,
      traces: action.payload,
    }),
    setDescriptionSignalId: (state, action: PayloadAction<string>) => ({
      ...state,
      descriptionSignalId: action.payload,
    }),
    setTooltipHovered: (state, action: PayloadAction<boolean>) => ({
      ...state,
      isTooltipHovered: action.payload,
    }),
    setIsModelInstanceGraph: (state, action: PayloadAction<boolean>) => ({
      ...state,
      isModelInstanceGraph: action.payload,
    }),
  },
})

// Action creators are generated for each case reducer function
export const {
  setOpen,
  setXValue,
  setTraces,
  setStaticTooltipOpen,
  setXPosition,
  setGlobalXDomain,
  setCursorPosition,
  setDescriptionSignalId,
  setTooltipHovered,
  setIsModelInstanceGraph,
} = sliceTooltip.actions

export const checkAndCloseTooltip =
  () =>
  (
    dispatch: (arg0: {payload: boolean; type: 'sliceTooltip/setOpen'}) => void,
    getState: () => RootState,
  ): void => {
    const {isTooltipHovered} = getState().sliceTooltip
    if (!isTooltipHovered) {
      dispatch(setOpen(false))
    }
  }

export default sliceTooltip.reducer
